<!-- CONTAINER -->
<div class="container content-area relative">

    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Astro Shop - Categories</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/mall-category/list']">Category List</a></li>
            <li class="breadcrumb-item active" aria-current="page">Details</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->
    
    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="border-top">
                    <div class="wideget-user-tab">
                        <div class="tab-menu-heading">
                            <div class="tabs-menu1">
                                <div class="card-body">
                                    <div class="border-0">
                                        <div class="tab-content">
                                            <div class="tab-pane active show" id="tab-51">
                                                <div id="profile-log-switch">
                                                    <div class="media-heading d-flex justify-content-between">
                                                        <h4>Category Details </h4>
                                                    </div>
                                                    <hr class="m-0">
                                                    <div class="table-responsive ">
                                                    <table class="user-table-custom table row table-bordered">
                                                            <!-- <tbody class="border-0 col-lg-12 col-xl-12 pr-0">
                                                                <tr>
                                                                    <td><strong>Title :</strong> {{data.blogTitle}}</td>
                                                                </tr>
                                                            </tbody> -->
                                                            <tbody class="border-0 col-lg-3 col-xl-3 col-sm-3 pr-0">
                                                                <tr>
                                                                    <td><strong>ID :</strong> #{{data.categoryId}}</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-3 col-xl-3 col-sm-3 p-0">
                                                                <tr>
                                                                    <td><strong>Name :</strong> {{data.categoryname}}
                                                                    <small *ngIf="data.is_front_category" class="rounded-1 p-1 text-bg-success">Highlight</small>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-3 col-xl-3 col-sm-3 p-0">
                                                                <tr>
                                                                    <td><strong>Slug :</strong> {{data.category_slug}}</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-3 col-xl-3 col-sm-3 p-0">
                                                                <tr>
                                                                    <td><strong>Category GST :</strong> {{data.category_gst}}%</td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-12 col-xl-12 pr-0">
                                                                <tr>
                                                                    <td><strong>Description :</strong> <div [innerHTML]="data.categorydescription"></div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-12 col-xl-12 pr-0">
                                                                <tr>
                                                                    <td><strong>Type: </strong><span class="rounded-1 p-1 text-bg-primary" *ngIf="!data?.is_product_associated && !data?.is_subcategory_associated">NEW</span>
                                                                        <span class="rounded-1 p-1 text-bg-info" *ngIf="data?.is_product_associated && !data?.is_subcategory_associated">PRODUCT ASSC.</span>
                                                                        <span class="rounded-1 p-1 text-bg-warning" *ngIf="!data?.is_product_associated && data?.is_subcategory_associated">SUBCAT. ASSC.</span></td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-12 col-xl-12 pr-0">
                                                                <tr>
                                                                    <td><strong>Keywords :</strong> <div [innerHTML]="data.category_keyword"></div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tbody class="border-0 col-lg-12 col-xl-12 pr-0">
                                                                <tr>
                                                                    <td><strong>Image :</strong> <img [src]="getSanitizeUrl(data.category_image)" class="img img-fluid"/></td>
                                                                </tr>
                                                            </tbody>                                                            
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->